"use client";

import { useCallback } from "react";
import { useTenantData, useWaiversGetPublic } from "@/hooks";
import { useTenantContentSettingsGet } from "@/features/profile-settings/hooks/useTenantContentSettingsGet";
import { resolveEffectiveTenantNumber } from "@/lib/utils/env/effective-tenant";
import { getTenantDisplayName } from "@/lib/utils/tenant";
import {
  TermsPageEmpty,
  TermsPageError,
  TermsPageSkeleton,
} from "./components";
import { TermsPageView } from "./TermsPageView";

const TENANT_ID = resolveEffectiveTenantNumber();

export const TermsPageClient = () => {
  const { tenantData } = useTenantData();
  const { data: contentSettings } = useTenantContentSettingsGet(
    { tenantId: TENANT_ID },
    { enabled: true },
  );

  const {
    items: waivers,
    isPending,
    isLoading,
    isError,
    isFetching,
    isSuccess,
    refetch,
  } = useWaiversGetPublic();

  const handleRetry = useCallback(() => {
    void refetch();
  }, [refetch]);

  if ((isLoading || isPending) && !isSuccess) {
    return <TermsPageSkeleton />;
  }

  if (isError) {
    return <TermsPageError onRetry={handleRetry} isRetrying={isFetching} />;
  }

  if (waivers.length === 0) {
    return <TermsPageEmpty variant="public" />;
  }

  return (
    <TermsPageView
      waivers={waivers}
      contentSettings={contentSettings}
      showStatus={false}
      tenantEmail={tenantData?.email}
      studioName={getTenantDisplayName(tenantData)}
    />
  );
};
